import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiClient from '../config/config';
import { supabase } from '../supabaseClient';
import Nav from './Nav';
import '../assets/css/psearch.css';

function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [creditsAdded, setCreditsAdded] = useState(0);
  const [totalCredits, setTotalCredits] = useState(0);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();
  }, []);

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setStatus('error');
        return;
      }

      try {
        const response = await apiClient.get('/stripe/verify-payment/', {
          params: { 
            session_id: sessionId,
            user_id: user?.id 
          }
        });

        if (response.data.success) {
          setStatus('success');
          setCreditsAdded(response.data.credits_added || 10);
          setTotalCredits(response.data.total_credits || 0);
        } else {
          setStatus('pending');
        }
      } catch (err) {
        console.error('Error verifying payment:', err);
        setStatus('error');
      }
    };

    if (user) {
      verifyPayment();
    }
  }, [searchParams, user]);

  return (
    <div className="payment-result-page">
      <Nav user={user} />
      <div className="payment-result-container">
        {status === 'verifying' && (
          <div className="payment-status verifying">
            <div className="loading-spinner"></div>
            <h2>Verifying your payment...</h2>
            <p>Please wait while we confirm your purchase.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="payment-status success">
            <div className="success-icon">✓</div>
            <h2>Payment Successful!</h2>
            <p>Thank you for your being part of YEMBERZAL!</p>
            <div className="credits-info">
              <div className="credits-added">
                <span className="credits-number">+{creditsAdded}</span>
                <span className="credits-label">credits added</span>
              </div>
              <div className="credits-total">
                <span>Total available: {totalCredits} try-ons</span>
              </div>
            </div>
            <button 
              className="continue-btn"
              onClick={() => navigate('/')}
            >
              Continue exploring
            </button>
          </div>
        )}

        {status === 'pending' && (
          <div className="payment-status pending">
            <div className="pending-icon">⏳</div>
            <h2>Payment Processing</h2>
            <p>Your payment is being processed. Credits will be added shortly.</p>
            <button 
              className="continue-btn"
              onClick={() => navigate('/')}
            >
              Return to Home
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="payment-status error">
            <div className="error-icon">✕</div>
            <h2>Something went wrong</h2>
            <p>We couldn't verify your payment. Please contact support if you were charged.</p>
            <button 
              className="continue-btn"
              onClick={() => navigate('/')}
            >
              Return to Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentSuccess;
